import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  const [searchUser, setSearchUser] = useState('');
  const navigate = useNavigate();


  ////////////////////// get token user and pass //////////////////
const token = localStorage.getItem("token")
    const decodedToken = jwtDecode(token);

    const username = decodedToken.username;
 
const mydb = username.slice(0, 3);

      
//////////////////////




  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch('/users?mydb='+mydb);
      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }
      const data = await response.json();
      setUsers(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  // Helper to generate avatar URL using ui-avatars.com with user's name
  const getAvatarUrl = (name, email) => {
    const baseUrl = 'https://ui-avatars.com/api/';
    const initials = name ? encodeURIComponent(name) : encodeURIComponent(email || 'User');
    return `${baseUrl}?name=${initials}&background=random&size=64&rounded=true`;
  };

  // Pagination logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  // Filter users by search
  let filteredUsers = users;
  if (searchUser) {
    const searchTerm = searchUser.toLowerCase();
    filteredUsers = filteredUsers.filter(user => 
      (user.name && user.name.toLowerCase().includes(searchTerm)) ||
      (user.username && user.username.toLowerCase().includes(searchTerm)) ||
      (user.email && user.email.toLowerCase().includes(searchTerm)) ||
      (user.user_type && user.user_type.toLowerCase().includes(searchTerm))
    );
  }

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  if (loading) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        backgroundColor: 'white', 
        borderRadius: '12px', 
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        margin: '20px auto',
        maxWidth: '1200px'
      }}>
        Loading users...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        color: '#e74c3c', 
        backgroundColor: 'white', 
        borderRadius: '12px', 
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        margin: '20px auto',
        maxWidth: '1200px'
      }}>
        Error: {error}
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => navigate('/Home')}
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#2980b9';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#3498db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '18px' }}>←</span>
            Home
          </button>
          
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search by name, username, email, or user type..."
            value={searchUser}
            onChange={(e) => setSearchUser(e.target.value)}
            style={{
              padding: '8px 12px',
              border: '1px solid #dce4ec',
              borderRadius: '8px',
              fontSize: '14px',
              width: '300px'
            }}
          />
          
          {/* Clear Button */}
          {searchUser && (
            <button
              onClick={() => setSearchUser('')}
              style={{
                padding: '8px 12px',
                backgroundColor: '#95a5a6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Clear
            </button>
          )}
        </div>
        
        <div style={{
          backgroundColor: '#27ae60',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Total Users: {filteredUsers.length}
        </div>
      </div>

      <h1 style={{
        color: '#2c3e50',
        textAlign: 'center',
        marginBottom: '30px',
        fontSize: '2.5rem',
        fontWeight: '300',
        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>Users Management</h1>

      {filteredUsers.length === 0 ? (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          color: '#7f8c8d', 
          backgroundColor: 'white', 
          borderRadius: '12px', 
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)' 
        }}>
          No users found
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {currentUsers.map((user) => (
            <div key={user.id} style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              transition: 'transform 0.2s ease',
            }}
            onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-2px)' }}
            onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)' }}>
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '15px 20px',
                color: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.2)'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(45deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%)',
                  pointerEvents: 'none'
                }}/>
                <div style={{ fontSize: '18px', fontWeight: '600' }}>
                  {user.name || user.username}
                </div>
                <div style={{ fontSize: '14px' }}>
                  ID: {user.id}
                </div>
              </div>
              <div style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <img
                  src={getAvatarUrl(user.name, user.email)}
                  alt={user.name || user.username}
                  style={{ 
                    width: '80px', 
                    height: '80px', 
                    borderRadius: '50%', 
                    border: '3px solid #f8f9fa',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                  }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '8px' }}>
                    {user.name || user.username}
                  </div>
                  <div style={{ fontSize: '14px', color: '#555', marginBottom: '4px' }}>
                    <strong>Username:</strong> {user.username}
                  </div>
                  <div style={{ fontSize: '14px', color: '#555', marginBottom: '4px' }}>
                    <strong>Email:</strong> {user.email || 'N/A'}
                  </div>
                  <div style={{ fontSize: '14px', color: '#555', marginBottom: '4px' }}>
                    <strong>User Type:</strong> 
                    <span style={{ 
                      backgroundColor: user.user_type === 'admin' ? '#e74c3c' : '#3498db',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      marginLeft: '8px'
                    }}>
                      {user.user_type || 'N/A'}
                    </span>
                  </div>
                  <div style={{ fontSize: '14px', color: '#555', marginBottom: '4px' }}>
                    <strong>Address:</strong> {user.address || 'N/A'}
                  </div>
                  <div style={{ fontSize: '14px', color: '#555' }}>
                    <strong>Phone:</strong> {user.tel1 || 'N/A'} {user.tel2 ? `| ${user.tel2}` : ''}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination Controls */}
      {!loading && !error && filteredUsers.length > 0 && (
        <div style={{ 
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          marginTop: '20px'
        }}>
          <button
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              padding: '8px 16px',
              backgroundColor: currentPage === 1 ? '#e9ecef' : '#3498db',
              color: currentPage === 1 ? '#6c757d' : 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            Previous
          </button>
          <span style={{ 
            display: 'flex', 
            alignItems: 'center',
            color: '#2c3e50',
            fontSize: '14px'
          }}>
            Page {currentPage} of {totalPages} ({filteredUsers.length} users)
          </span>
          <button
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage >= totalPages}
            style={{
              padding: '8px 16px',
              backgroundColor: currentPage >= totalPages ? '#e9ecef' : '#3498db',
              color: currentPage >= totalPages ? '#6c757d' : 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Users;
 